import {DetailRow} from './LASGInvoiceCard';

const LASGReceiptCard = ({receipt}) => {
    const {receipt_url, trans_id, trans_code, response_code} = receipt || {};

    return (
        <div className="mb-4">
            <div className="bg-light border rounded-3 p-3 mt-2">
                <p
                    className="text-uppercase fw-bold text--gray mb-3"
                    style={{letterSpacing: '0.6px'}}
                >
                    LASG Receipt Details
                </p>
                <ul className="list-group list-group-flush">
                    <DetailRow label="Transaction ID" value={trans_id} />
                    <DetailRow label="Transaction Code" value={trans_code} />
                    <DetailRow label="Status" value={response_code} valueClassName="text-success" />
                </ul>
            </div>
            {receipt_url && (
                <a
                    href={receipt_url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="btn btn--primary w-100 mt-4 text-decoration-none"
                >
                    View Payment Receipt
                </a>
            )}
        </div>
    );
};

export default LASGReceiptCard;
